import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../../services/wealthlane-award-services';
import { BrokerSsoConfigurationKeyService } from '../../services/wealthlane-identity-services/services/BrokerSsoConfigurationKeyService';
import { type Wealthlane_Dtos_SsoProvider_CreateUpdateBrokerSsoConfigurationKeyDto } from '../../services/wealthlane-identity-services/models/Wealthlane_Dtos_SsoProvider_CreateUpdateBrokerSsoConfigurationKeyDto';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';

const usePostBrokerSsoConfigurationKey = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess: () => void,
  id?: string
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  Wealthlane_Dtos_SsoProvider_CreateUpdateBrokerSsoConfigurationKeyDto,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: Wealthlane_Dtos_SsoProvider_CreateUpdateBrokerSsoConfigurationKeyDto) => {
      if (id != null && id !== '') {
        return await handleRequest(
          BrokerSsoConfigurationKeyService.putApiIdentityApiAppBrokerSsoConfigurationKey(
            id,
            payload
          )
        );
      }
      return await handleRequest(
        BrokerSsoConfigurationKeyService.postApiIdentityApiAppBrokerSsoConfigurationKey(payload)
      );
    },
    {
      onSuccess: (data) => {
        if (data != null) {
          void queryClient.invalidateQueries('getBrokerSsoKeyManagementList');
          toast.success(
            <ToastComponent
              label='Success'
              message={`Broker SSO Configuration Key ${id ? 'edited' : 'added'} successfully.`}
            />
          );
          onSuccess();
        }
      },
      onError: (err) => {
        console.error('usePostBrokerSsoConfigurationKey error:', err);
      },
    }
  );
};

export default usePostBrokerSsoConfigurationKey;
